import type { Icon } from '../../../src/lib/types'
export const mdiAlignHorizontalDistribute: Icon = {
  "id": "align-horizontal-distribute",
  "name": "Align Horizontal Distribute",
  "path": "M4 22H2V2H4V22M22 2H20V22H22V2M13.5 7H10.5V17H13.5V7Z",
  "as": [],
  "tags": [
    "Text / Content / Format"
  ]
}
export default mdiAlignHorizontalDistribute